import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import Button from '../../components/Button';
import VerifyDependentStep1 from '../../pages/widgets/verifyDependent/verifyDependentStep1';
import Stepper from './Stepper';

const steps = [
  {
    title: 'Relationship',
    child: (
      <VerifyDependentStep1
        data={[]}
        collectStepData={(data) => {
          console.log(data);
        }}
      />
    ),
  },
  {
    title: 'Documentation',
    child: (
      <Container className="p-10 d-flex justify-content-center">
        <h2>Documentation</h2>
      </Container>
    ),
  },
  {
    title: 'Social Security Number',
    child: (
      <Container className="p-10 d-flex justify-content-center">
        <h2>Social Security Number</h2>
      </Container>
    ),
  },
  {
    title: 'Review & Submit',
    child: (
      <Container className="p-10 d-flex justify-content-center">
        <h2>Review & Submit</h2>
      </Container>
    ),
  },
];

const StepperDemo = () => {
  const [step, setStep] = React.useState(0);

  const handleStepForward = () => {
    setStep(step + 1);
  };

  const handleStepBackward = () => {
    setStep(step - 1);
  };

  return (
    <Container>
      <Container>
        <h4>Stepper Demo</h4>
        <Row className="m-0">
          <Stepper currentStepIndex={step} steps={steps} />
        </Row>
      </Container>
      <Container className="m-0 d-flex flex-row justify-content-center">
        <div className="px-10">
          <Button
            variant="primary-outline"
            leftIcon={light('arrow-left')}
            onClick={handleStepBackward}
            disabled={step === 0}
          >
            Previous
          </Button>
        </div>
        <div className="px-10">
          <Button
            variant="primary-outline"
            onClick={() => console.log('CANCEL')}
          >
            Cancel
          </Button>
        </div>
        <div className="px-10">
          <Button
            variant="primary-outline"
            onClick={handleStepForward}
            disabled={step === steps.length - 1}
          >
            Continue
          </Button>
        </div>
      </Container>
    </Container>
  );
};

export default StepperDemo;
